<template>
  <div class="head-box">
    <div class="a-box">
      <div class="logo-box">
        <img class="logo" src="https://card-pord.oss-cn-hangzhou.aliyuncs.com/equity-official-website/xinqiyi/xinqiyi-logo.png"/>
        <span class="equity-title">新奇翼会员</span>
      </div>
      <div class="style-a-box">
        <a :style="{ color: titleFlag === 1 ? '#6189FA' : 'black' }"  @click="changeHash(1,'#home')">首页</a>
        <div v-if="titleFlag === 1" class="line-box"></div>
      </div>
      <div class="style-a-box">
        <a :style="{ color: titleFlag === 2 ? '#6189FA' : 'black' }" @click="changeHash(2,'#product')">产品介绍</a>
        <div v-if="titleFlag === 2" class="line-box"></div>
      </div>
      <div class="style-a-box">
        <a :style="{ color: titleFlag === 3 ? '#6189FA' : 'black' }" @click="changeHash(3,'#home')">订单查询</a>
        <div v-if="titleFlag === 3" class="line-box"></div>
      </div>
      <div class="style-a-box">
        <a :style="{ color: titleFlag === 4 ? '#6189FA' : 'black' }" @click="changeHash(4,'#phone')">联系我们</a>
        <div v-if="titleFlag === 4" class="line-box"></div>
      </div>
      <div class="style-a-box">
        <a :style="{ color: titleFlag === 5 ? '#6189FA' : 'black' }" @click="handleClickIntroduction(5)">关于我们</a>
        <div v-if="titleFlag === 5" class="line-box"></div>
      </div>
    </div>
  </div>
  <nav>
    <router-link to></router-link>
  </nav>
  <router-view/>
</template>

<script setup>
import router from "@/router";
import {ref, onMounted} from "vue";

const titleFlag = ref(1)
onMounted( ()=>{
  if(sessionStorage.getItem('titleFlag')){
    titleFlag.value = Number(sessionStorage.getItem('titleFlag'))
  } else {
    sessionStorage.setItem('titleFlag', '1')
    titleFlag.value = 1
  }
})

function changeHash (id,idName) {
  titleFlag.value = id
  sessionStorage.setItem('titleFlag', id)
  router.push({path:'/', hash: idName })
  document.querySelector(idName)?.scrollIntoView({ behavior: 'smooth' })

}
function handleClickIntroduction (id) {
  titleFlag.value = id
  sessionStorage.setItem('titleFlag', id)
  router.push({path:'/introduction'})
}
</script>
<style lang="less">
.head-box{
  width: 100%;
  height: 28px;
  position: fixed;
  top: 0; /* 可以调整位置 */
  left: 0; /* 可以调整位置 */
  background: #FFF;;
  display: flex;
  z-index: 9999;
  justify-content: flex-end;
  align-items: center; /* 这个属性会使得子元素垂直居中 */
  .a-box{
    margin-right: 70px;
    height: 10px;
    display: flex;
    .logo-box{
      width: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 180px;
      .logo {
        width: 16px;
        height: 16px;
        display: block;
        margin-right: 2px;
      }
      .equity-title{
        width: 80px;
        color: #6189FA;
        font-size: 7.5px;
        font-weight: 550;
        line-height: 16px;
      }
    }
    .style-a-box{
      width: 50px;
      text-align: center;
      a {
        display:block;
        font-size: 6px;
        text-decoration: none;
        color: #313335
      }
      a:hover{
        cursor: default;
      }
      .line-box{
        margin: 5px auto;
        width: 10px;
        height: 2px;
        border-radius: 1.5px;
        background: linear-gradient(90deg, #9FB2FC 0%, #74C0FF 100%), #F7CB9A;
      }
    }
  }
}
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
